import {
    ExtendedAreaModels,
    mergeConstructionNumberSpecification,
    mergeDecimalRange,
    mergePropertySpecification,
} from '@bpd-library/utilities';
import { FILTER_NAMES } from '@features/properties/components/property-filter';
import isRangeWithinRange from '@source/utilities/filters/is-range-in-range';
import { hasFilterUrl } from '@source/utilities/filters/urls';
import { translateItem } from '@source/utilities/hooks';

import { generateSteps } from '../utilities/generate-steps';
import { Filters } from './construct-filters';

const getPlotAreaSteps = (data: ExtendedAreaModels): number[] => {
    const filteredPropertyTypes = data.propertyTypes.filter(
        ({ constructionNumbers }) => !constructionNumbers?.length,
    );

    const constructionNumberRange = mergeConstructionNumberSpecification(
        data.constructionNumbers,
        'plotArea',
    );
    const propertyTypeRange = mergePropertySpecification(
        { propertyTypes: filteredPropertyTypes },
        'plotArea',
    );

    const plotAreaRange = mergeDecimalRange(constructionNumberRange, propertyTypeRange);

    const steps = generateSteps({
        range: plotAreaRange,
        stepSize: 25,
    });

    return steps;
};

export const setPlotAreaFilters = async (data: ExtendedAreaModels, filters: Filters) => {
    const steps = getPlotAreaSteps(data);
    const filterName = FILTER_NAMES.plotArea;

    if (steps.length) {
        filters[filterName] = {
            expanded: false,
            icon: 'specs-surface',
            title: await translateItem('Filters.PlotArea.label'),
            dropdownLabel: await translateItem('Filters.PlotArea.dropdownLabel'),
            filterFunctions: {
                constructionNumber: (constructionNumber, filterInput) => {
                    if (!constructionNumber.specifications?.plotArea) return false;

                    return isRangeWithinRange(
                        {
                            from: parseInt(filterInput.value),
                        },
                        constructionNumber.specifications?.plotArea,
                    );
                },
                propertyType: (propertyType, filterInput) => {
                    if (!propertyType.specifications?.plotArea) return false;

                    return isRangeWithinRange(
                        {
                            from: parseInt(filterInput.value),
                        },
                        propertyType.specifications?.plotArea,
                    );
                },
                projectPhase: (projectPhase, filterInput) => {
                    if (!projectPhase.propertySpecifications?.plotArea) return false;

                    return isRangeWithinRange(
                        {
                            from: parseInt(filterInput.value),
                        },
                        projectPhase.propertySpecifications?.plotArea,
                    );
                },
            },
            filterName,
            hasRangeValues: true,
            filters: {
                type: 'radio',
                components: steps.map((step) => ({
                    id: `${filterName}-${step}`,
                    label: `${step}+ m2`,
                    value: `${step}`,
                    name: filterName,
                    checked: hasFilterUrl(`${step}`, filterName),
                    type: 'radio',
                })),
            },
        };
    }
};
